<template>
  <div class="w-full flex flex-col gap-2">

    <!-- If productData == null, we're in the form editor's preview mode -->
    <div v-if="productData == null" class="w-full p-2 border border-trader-input-border">
      <p class="mb-2">Table Input Preview</p>
      <p>Rows: {{ tableData.length }}, Cols: {{ tableData[0]?.length }}</p>
    </div>

    <!-- Otherwise, display the actual table input -->
    <div v-else class="w-full flex flex-col gap-2">
      <!-- form -->


      <table v-if="tableData?.length > 0" class="flex-grow border-trader-dark-gray">
        <tbody>
        <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
          <td
              v-for="(cell, colIndex) in row"
              :key="colIndex"
              class="border border-white cursor-pointer bg-trader-gray p-1"
          >
            <div v-if="cell.length === 0" class="text-gray-500 italic">
            </div>
            <div v-else class="flex gap-1 items-center">
              <template v-for="(comp, compIndex) in cell" :key="compIndex">
                <span v-if="comp.type === 'text'" class="">{{ comp.text }}</span>
                <input :data-load="loadField(comp.tag)"
                       v-else-if="comp.type === 'input'"
                       type="text"
                       class="px-1 py-0.5 border rounded w-full"
                       :class="{ 'bg-trader-red': this.productData.customFields[comp.tag].highlight }"
                       :value="localGetFieldValue(comp.tag)"
                       :placeholder="comp.placeholder"
                       @input="e => onChange(comp.tag, e.target.value)"
                       @blur="onBlur()"
                />
                <select v-else-if="comp.type === 'dropdown'" :data-load="loadField(comp.tag)"
                        class="px-1 py-0.5 border rounded"
                        :class="{ 'outline outline-trader-red': this.productData.customFields[comp.tag].highlight }"
                        @change="e => onChange(comp.tag, e.target.value)">
                  <option v-for="(option, optIndex) in comp.options" :key="optIndex"
                          :value="option.value" :selected="option.value === localGetFieldValue(comp.tag)">
                    {{ option.label }}
                  </option>
                </select>
              </template>
            </div>
          </td>
        </tr>
        </tbody>
      </table>


      <!-- end form -->
    </div>
  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus";
import DCustomizableTableOptions from "@/customizations/selgros/Dialogs/DCustomizableTableOptions.vue";

export default {
  name: "TableInput",
  meta: {
    name: "Table Input",
    type: "fieldtype",
    version: "1.0.0",
    hasOptions: true,
    hideLabel: true,
  },
  props: {
    name: {
      type: String,
      default: "Table Input",
    },
    formField: {
      type: Object,
      default: () => ({}),
    },
    productData: {
      type: Object,
      default: () => ({}),
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {
      },
    },
    onBlur: {
      type: Function,
      default: () => {
      },
    },
    getFieldValue: {
      type: Function,
      default: () => {
      },
    },
    onFormEvent: {
      type: Function,
      default: () => {
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let parsed = [];
    try {
      parsed = JSON.parse(this.formField.value);
    } catch (e) {
    }

    

    return {
      showDropdown: false,
      tableData: parsed || [],
      isUpdating: false,
    }
  },
  mounted() {
    this.initializeFromValue();
    // If your form system uses onFormEvent like the bullet list example,
    // you can watch for reset events:
    this.onFormEvent("reset", this.initializeFromValue);
  },
  watch: {
    // If productData changes externally (e.g., by the system),
    // re-initialize the table content from the new data:
    productData: {
      immediate: true,
      handler() {
        this.initializeFromValue();
      },
      deep: true,
    },
  },
  methods: {
    loadField(tag) {
      try {
        if (this.productData.customFields[tag].value) {
          return this.productData.customFields[tag].value;
        }
      } catch (e) {
        this.productData.customFields[tag] = {value: "", highlight: false};
      }
    },
    localGetFieldValue(fieldName) {
      return this.productData?.customFields[fieldName]?.value || '';
    },

    onChange(fieldName, value) {
      
      this.onChangeProductFieldValue(fieldName, null, value)
    },

    // Load existing table data from the custom field:
    initializeFromValue() {
      const rawValue = this.getFieldValue(this.formField.field) || "";
      if (rawValue.trim()) {
        try {
          const parsed = JSON.parse(rawValue);
          // Only set tableData if parsed is an array of arrays
          if (Array.isArray(parsed) && Array.isArray(parsed[0])) {
            this.tableData = parsed;
            return;
          }
        } catch (err) {
          // If JSON parse fails, fallback to a single empty cell
          console.warn("Invalid table JSON", err);
        }
      }
      // Default if no valid data
      //this.tableData = [[""]];
    },

    // Save the table data back to the product’s custom field
    /*
    async updateFieldValue() {
      try {
        const jsonString = JSON.stringify(this.tableData);
        await this.onChangeProductFieldValue(
            this.formField.field,
            "string",
            jsonString
        );
      } catch (error) {
        console.error("Error updating table field value:", error);
      }
    },
    */


  },
  showOptions(value, callback) {
    eventBus.openModal(
        DCustomizableTableOptions,
        {
          title: "Optionen für Tabelle",
          setData: value,
          onApply: callback
        },
        {
          halfSize: true
        }
    );
  }
};
</script>

<style scoped>


th, td {
  border: 2px solid var(--color-trader-light-gray, #ccc);
}


</style>
